import CountUp from "react-countup";

const AboutCountCard = ({ text, count }) => {
  return (
    <div className="sm:w-[200px] w-[280px] h-[150px]  shadow-md mx-3 my-2 rounded-lg flex items-center flex-col justify-center">
      <CountUp className="bg-gradient-to-r mt-2 from-[#FE4904] to-[#F7164C] text-transparent bg-clip-text text-4xl font-semibold" end={count} duration={3} />
      <h2 className="mt-2 text-xl font-medium">{text}</h2>
    </div>
  );
};
export default AboutCountCard;
